export default __webpack_public_path__ + "static/media/no_tutors.5d652d81.svg";